// src/pages/Dashboard.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../styles/Dashboard.css";

const DASHBOARD_LINKS = [
  {
    to: "/dashboard/mycateringbookings",
    title: "Catering Bookings",
    subtitle: "Event orders and guest planning",
    description:
      "View menu selections, event dates, headcount, and booking status updates.",
    accent: "catering",
    badge: "CK",
  },
  {
    to: "/dashboard/mychefbookings",
    title: "Madi Samayal Bookings",
    subtitle: "Chef at home requests",
    description:
      "Track chef schedules, preparation notes, and service confirmations in one place.",
    accent: "chef",
    badge: "MS",
  },
  {
    to: "/dashboard/mydailyfoodbookings",
    title: "Daily Food Orders",
    subtitle: "Cloud kitchen subscriptions",
    description:
      "Manage recurring meal plans, skips, and delivery history from your dashboard.",
    accent: "daily",
    badge: "DF",
  },
];

const Dashboard = () => {
  return (
    <section className="dashboard-page">
      <header className="dashboard-page-header">
        <h1>My Dashboard</h1>
        <p>Manage all your bookings from one optimized control center</p>
      </header>

      <section className="dashboard-kpi-grid" aria-label="Dashboard summary">
        <article className="dashboard-kpi-card">
          <span className="kpi-label">Sections</span>
          <strong className="kpi-value">3</strong>
          <span className="kpi-meta">Booking hubs available</span>
        </article>

        <article className="dashboard-kpi-card">
          <span className="kpi-label">Access</span>
          <strong className="kpi-value">Live</strong>
          <span className="kpi-meta">Synced with your account</span>
        </article>

        <article className="dashboard-kpi-card">
          <span className="kpi-label">Support</span>
          <strong className="kpi-value">24/7</strong>
          <span className="kpi-meta">Track and update anytime</span>
        </article>
      </section>

      <header className="dashboard-section-header">
        <h2>Quick Navigation</h2>
        <p>Choose where you want to continue</p>
      </header>

      <div className="dashboard-card-grid">
        {DASHBOARD_LINKS.map((item) => (
          <Link to={item.to} className={`dashboard-card ${item.accent}`} key={item.to}>
            <div className="dashboard-card-top">
              <span className="dashboard-card-icon" aria-hidden="true">
                {item.badge}
              </span>
              <span className="dashboard-card-subtitle">{item.subtitle}</span>
            </div>

            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <span className="dashboard-card-cta">Open section</span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Dashboard;
